import AbstractScene from './AbstractScene.js';
import RoundedButton2 from '../prefabs/RoundedButton2.js';
import { Colors } from '../consts/Colors.js';
import Popup from '../prefabs/Popup.js';
import PopupFin from '../prefabs/PopupFin.js';
import Deck1 from '../prefabs/game1/Deck1.js';
import Zone1 from '../prefabs/game1/Zone1.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame1';

export default class Game1 extends AbstractScene {
    constructor() {
        super({
            key: "Game1"
        })
    }
    init(data) {
        this._init(data);
        this.zonesInfos = ZonesInfos;
        this.newCards = []
    }

    preload() {
        this._preload();
    }

    create() {
        CartesInfos.sort(() => Math.random() - 0.5);
        this.background = this.add.image(0, 0, 'background1').setOrigin(0);
        // this.consigne = this.createTextElement(1538, 792, TextContents.consigne)
        this.addDropZone()
        this.addAllLittleCards()

        this.transitionRect = this.add.rectangle(1904, 16, 400, 1048, Colors.Elmt.DarkBlue, 1).setOrigin(1, 0)
        this.deck1 = new Deck1(this, 1700, 540, 336, 490);
        this.zone1.addDeck(this.deck1);
        this.zone2.addDeck(this.deck1);
        this.deck1.setDeckAction(CartesInfos[0])
        this.launchPopup();
        // this.endGame()
    }
    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 756, true);
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            this.zones.getChildren().forEach(zone => {
                zone.setActive();

            });
        })
    }

    launchEndPopup() {
        this.popup = new PopupFin(this, TextContents.popupFin.text, 756);
        this.popup.introBtn.setClickFunction(() => {
            this.transitionOut()

        })
    }


    addDropZone() {
        this.zones = this.add.group();
        this.zone1 = new Zone1(this, this.zonesInfos[0]);
        this.zones.add(this.zone1);
        this.zone2 = new Zone1(this, this.zonesInfos[1]);
        this.zones.add(this.zone2);
        this.zone1.otherZone = this.zone2;
        this.zone2.otherZone = this.zone1;
        this.btmLine = this.add.image(756, 962, 'btmLine').setOrigin(0.5);


    }

    addAllLittleCards() {
        for (let i = 0; i < CartesInfos.length; i++) {
            const element = CartesInfos[i];
            let card = this.add.image(element.zoneX, element.zoneY, element.image).setOrigin(0.5).setDepth(0).setAlpha(0)
            card.setName(element.index)

            this.newCards.push(card)
            if (element.zoneId === 0) {
                card.setScale(1.4)
            } else {
                card.setScale(1)
            }
        }
    }

    addCardOnZone(cardData) {
        let selectedCard = this.newCards.find(card => card.name === cardData.index);
        selectedCard.setAlpha(1)
        if (cardData.zoneId === 1) {
            selectedCard.setScale(1)
        } else {
            selectedCard.setScale(1.4)
        }
    }

    transitionOut() {
        this.tweens.add({
            targets: this.deck1,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.transitionRect.setDepth(12)
                this.tweens.add({
                    targets: this.transitionRect,
                    width: 1488,
                    duration: 500,
                    onUpdate: () => {
                        this.transitionRect.x = 1904 - this.transitionRect.width
                    },
                    onComplete: () => {
                        this.scene.start('Game2')
                    }
                })

            }
        })

    }

    endGame() {
        this.bordure = this.add.image(756, 560, 'bordureFin').setOrigin(0.5);
        this.cartouche = this.add.image(736, 109, 'cartoucheFin').setOrigin(0.5)
        let rect1 = this.add.rexRoundRectangle(449, 426, 576, 228, {
            tl: 26,
            tr: 26,
            bl: 0,
            br: 0
        }, Colors.Elmt.DarkBeige).setOrigin(0.5, 1);
        this.warning = this.add.image(449, 260, 'warning').setOrigin(0.5);
        this.minus = this.add.image(762, 925, 'minusLogo').setOrigin(0.5);
        this.tweens.add({
            targets: [this.cartouche, this.warning, this.minus],
            alpha: 0,
            duration: 500,
            repeat: -1,
            yoyo: true,
        })


        this.zone1.addDotLine()
        this.zone2.addDotLine()
    }
}